import * as React from 'react';
import { Box, Typography, Container, Grid, Card,
  CardContent,} from "@mui/material";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation, Autoplay} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import temple from '../assets/images/Temple.png';
import tkstemple from '../assets/images/Slider-images-TSCT1.jpg';
import bg1 from '../assets/images/about-us-2.png';
import br from '../assets/images/bottom.png';
import "../styles/Aboutus.css";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import HotelOutlinedIcon from "@mui/icons-material/HotelOutlined";
import TempleHinduOutlinedIcon from "@mui/icons-material/TempleHinduOutlined";
import FestivalOutlinedIcon from "@mui/icons-material/FestivalOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import CleaningServicesOutlinedIcon from "@mui/icons-material/CleaningServicesOutlined";
import { useNavigate } from "react-router-dom";
import bg from '../assets/images/Sirkazhi_Temple_2.jpeg';
function AboutUs() {
  const navigate = useNavigate();
 return (
  <Box>
    <Box
        sx={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "40% top 20%",
          height: "80vh",
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "white",
          position: "relative",
        }}
      >
        {/* Overlay for better readability */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          }}
        />

        <Typography
          sx={{
            fontWeight: "bold",
            zIndex: 1,
            color: "#FFCC03",
            fontSize: {
              xs: "2rem",     // Mobile
              sm: "2.5rem",   // Tablets
              md: "3rem",     // Medium screens
              lg: "3.5rem",   // Large screens
              xl: "4rem"      // Extra large screens
            },
            textAlign: "center",
            px: 2
          }}
        >
          About Us
        </Typography>

        <Typography
          sx={{
            fontWeight: "bold",
            zIndex: 1,
            mt: 2,
            color: "white",
            fontSize: {
              xs: "1.2rem",    // Smallest screen
              sm: "1.5rem",
              md: "1.75rem",
              lg: "2rem",
              xl: "2.25rem"
            },
            textAlign: "center"
          }}
        >
          Empowering community through compassion, <span style={{ color: "white" }}>unity, and lasting impact.</span>
        </Typography>
      </Box>
      {/* About Us Section */}
      <Box sx={{ backgroundColor: "#f8f9e9", py: 6 }}>
      

  <Container>
    <Grid container spacing={4} alignItems="center">
      
      {/* 1️⃣ About Us Heading - Always First on Mobile */}
      <Grid item xs={12} order={{ xs: 1, md: 1 }}>
        <Typography variant="h2" sx={{ fontWeight: "bold", color: "#E52029", textAlign: "center", fontSize: "34px" }}>
          About <span style={{ color: "#FAD707" }}>Us</span>
        </Typography>
      </Grid>

      {/* 2️⃣ Image - Second on Mobile, First on Desktop */}
      <Grid item xs={12} md={6} order={{ xs: 2, md: 2 }}>
            <Box
        component="img"
        src={temple}
        alt="Temple"
        sx={{
          width: "100%", 
          maxWidth: "400px", 
          display: "block",
          margin: "0 auto",
          borderRadius: "30px",
        }}
      />
      </Grid>
      {/* 3️⃣ Content - Third on Mobile, Second on Desktop */}
      <Grid item xs={12} md={6} order={{ xs: 3, md: 1 }} sx={{ position: "relative" }}>
        
        {/* Swiper Component */}
        <Swiper
          navigation={{
            prevEl: ".custom-prev",
            nextEl: ".custom-next",
          }}
          autoplay={{ delay: 30000, disableOnInteraction: false }}
          loop={true}
          modules={[Navigation, Autoplay]}
          className="swiper-container"
        >
          <SwiperSlide>
            <Typography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: "16px",
                color: "black",
                lineHeight: 2.3,
                fontWeight: 500,
                textAlign: "justify",
                px: { xs: 2, md: 5 },
              }}
            >
              Welcome to Thirukadaiyur Charitable Trust, a non-profit organization dedicated to uplifting 
              and supporting through various initiatives focused on education, marriage, and other social welfare programs.
              Founded with the vision of fostering unity, equality, and prosperity, Thirukadaiyur Charitable Trust aims 
              to provide essential resources and opportunities to those who need them the most. Our mission is to empower 
              individuals, especially the underprivileged, by offering educational scholarships, organizing mass marriages, 
              and providing financial support for various personal and social development needs.
            </Typography>
          </SwiperSlide>
          <SwiperSlide>
            <Typography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: "16px",
                color: "black",
                fontWeight: 500,
                lineHeight: 2.0,
                textAlign: "justify",
                px: { xs: 2, md: 5 },
              }}
            >
              திருக்கடையூர் அறக்கட்டளைக்கு வரவேற்கிறோம், ஒற்றுமை, சமத்துவம் மற்றும் செழிப்பு ஆகியவற்றை வளர்க்கும் நோக்குடன் 
              நிறுவப்பட்ட திருக்கடையூர் அறக்கட்டளை, மிகவும் தேவைப்படுபவர்களுக்கு அத்தியாவசிய தேவைகளையும், வாய்ப்புகளையும் 
              வழங்குவதை நோக்கமாகக் கொண்டுள்ளது. கல்வி உதவித்தொகை, வெகுஜன திருமணங்களை ஏற்பாடு செய்தல் மற்றும் பல்வேறு தனிப்பட்ட 
              மற்றும் சமூக மேம்பாட்டு தேவைகளுக்கு நிதியுதவி வழங்குவதன் மூலம் தனிநபர்களுக்கு, குறிப்பாக பின்தங்கியவர்களுக்கு 
              அதிகாரமளிப்பதே எங்கள் நோக்கம்.
            </Typography>
          </SwiperSlide>
        </Swiper>

        {/* Custom Navigation Buttons */}
        <button
  className="custom-prev"
  style={{
    position: "absolute",
    top: "50%",
    left: "20px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❮
</button>

<button
  className="custom-next"
  style={{
    position: "absolute",
    top: "50%",
    right: "-10px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❯
</button>
      </Grid>

    </Grid>
    <Box
  
/>
  </Container>
</Box>   
<Box sx={{ backgroundColor: "#f8f9e9", py: 6 }}>
  <Container>
    <Grid container spacing={4} alignItems="center">
      
      {/* 📍 1️⃣ Heading (Appears First in Mobile, Stays with Content in Desktop) */}
      <Grid 
        item xs={12} 
        sx={{ display: { xs: "block", md: "none" }, textAlign: "center", mb: 2 }}
      >
        <Typography variant="h4" sx={{ fontWeight: "bold", color: "#E52029", fontSize: "34px" }}>
          Our <span style={{ color: "#FAD707" }}>Mission</span>
        </Typography>
      </Grid>

      {/* 📍 2️⃣ Image Section (Left on Desktop, Below Heading on Mobile) */}
      <Grid item xs={12} md={6}>
        <Box
          component="img"
          src={bg1}
          alt="Tks_trust_Temple"
          sx={{
            width: "80%",
            height: "270px", 
            borderRadius: "8px",
            boxShadow: 3,
            display: "block",
            maxWidth: { xs: "90%", md: "100%" },  // Responsive width
            margin: "0 auto"
          }}
        />
      </Grid>

      {/* 📍 3️⃣ Content + Swiper (Right on Desktop, Below Image on Mobile) */}
      <Grid item xs={12} md={6} sx={{ position: "relative" }}>
        
        {/* 🖥️ Desktop Heading (Only visible on Desktop) */}
        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: "bold", 
            fontsize: "34px",
            color: "#E52029",
            display: { xs: "none", md: "block" } // Hide in mobile, show in desktop
          }}>
          Our <span style={{ color: "#FAD707" }}>Mission</span>
        </Typography>

        <Swiper
          navigation={{
            prevEl: ".custom-prev1",
            nextEl: ".custom-next1",
          }}
          autoplay={{ delay: 11000, disableOnInteraction: false }}
          loop={true}
          modules={[Navigation, Autoplay]}
          className="swiper-container"
        >
          <SwiperSlide>
            <Typography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: "16px",
                color: "#000000",
                fontWeight: 500,
                lineHeight: 2.3,
                textAlign: "justify",
                px: { xs: 2, md: 5 },  // Adjusted padding for mobile
              }}
            >
              We strive to empower fostering education, cultural preservation, and social well-being. 
              Through collective efforts, we aim to create opportunities and resources that benefit 
              everyone in this region.
            </Typography>
          </SwiperSlide>

          <SwiperSlide>
            <Typography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: "16px",
                color: "#000000",
                fontWeight: 500,
                textAlign: "justify",
                px: { xs: 2, md: 5 },  // Adjusted padding for mobile
              }}
            >
              கல்வி, கலாச்சார பாதுகாப்பு மற்றும் சமூக நல்வாழ்வை வளர்ப்பதன் மூலம் சமூகத்தை மேம்படுத்த 
              நாங்கள் முயற்சி செய்கிறோம். கூட்டு முயற்சிகள் மூலம், பயனளிக்கும் வாய்ப்புகளையும் 
              வளங்களையும் உருவாக்குவதை நோக்கமாகக் கொண்டுள்ளோம்.
            </Typography>
          </SwiperSlide>
        </Swiper>

        {/* Custom Navigation Buttons */}
        <button
  className="custom-prev1"
  style={{
    position: "absolute",
    top: "50%",
    left: "20px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❮
</button>

<button
  className="custom-next1"
  style={{
    position: "absolute",
    top: "50%",
    right: "-10px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❯
</button>
      </Grid>

    </Grid>
  </Container>
  <Box
  sx={{
    position: "relative",
    left:"50%",
    width: "40%",
    height: { xs: "80px", md: "150px" }, // Smaller height on mobile, larger on desktop
    backgroundImage: `url(${br})`,
    backgroundSize: "cover", // Ensures full coverage on all screen sizes
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    marginTop: { xs: "-50px", md: "-100px" }, // Adjusts placement for mobile & desktop
    zIndex: 0, // Ensures it stays below content
  }}
/>

</Box>

{/* Our Initiatives Section */}
<div className="bg-[#f8f9e9] text-center py-12">
    <Typography variant="h2" sx={{ fontWeight: "bold", color: "#E52029", fontSize: "34px" }}>
        Our <span style={{ color: "#FAD707" }}>Initiatives</span>
      </Typography>
      <Typography variant="h5" sx={{ fontSize: "16px" }} className="mt-4 text-lg">
      <br /> 
        Supporting community well-being through facilities, education, and cultural preservation.
      </Typography>
      <Typography variant="h6" sx={{ fontSize: "16px" }}  className="mt-2 text-lg font-bold">
        
      சூழல், கல்வி மற்றும் பாரம்பரிய பாதுகாப்பின் மூலம் சமூக நலத்தை ஆதரிக்கிறோம்.
      </Typography>

  <Container maxWidth="lg" className="mt-8">
  <Grid container spacing={4}>
    {[
      {
        title: "Kalyana Mandapam & Rooms",
        description:
          "Building a new facility in Thirukadaiyur to support families and individuals visiting the holy site, ensuring convenience and comfort.",
        tamilDescription:
          "திருக்கடையூர் புனித தலத்திற்கு வருகை தரும் குடும்பங்கள் மற்றும் தனிநபர்களுக்கு ஆதரவு அளிக்கும் புதிய வசதிகளை உருவாக்குதல்.",
        icon: <HotelOutlinedIcon sx={{ fontSize: 60 }} />,
      },
      {
        title: "Cultural Preservation",
        description:
          "Promoting and preserving the traditions, festivals, and practices that define identity.",
        tamilDescription:
          "நமது அடையாளத்தை வரையறுக்கும் மரபுகள், பண்டிகைகள் மற்றும் நடைமுறைகளை ஊக்குவித்தல் மற்றும் பாதுகாத்தல் ஆகும்.",
        icon: <FestivalOutlinedIcon sx={{ fontSize: 60 }} />,
      },
      {
        title: "Student Welfare",
        description:
          "Contributing 10% of annual collections towards student support programs, guided by an expert committee to ensure impactful distribution.",
        tamilDescription:
          "மாணவர் ஆதரவு திட்டங்களுக்கு ஆண்டு சேகரிப்புகளில் 10% பங்களிப்பை வழங்குதல், பயனுள்ள விநியோகத்தை உறுதி செய்வதற்காக ஒரு நிபுணர் குழுவால் வழிநடத்தப்படுகிறது.",
        icon: <SchoolOutlinedIcon sx={{ fontSize: 60 }} />,
      },
    ].map((item, index) => (
      <Grid item xs={12} md={4} key={index}>
        {/* Group wrapper to apply hover effect to both card and icon */}
        <div className="group transition-all duration-500">
          <Card className="bg-[#f8f9e9] border border-gray-300 rounded-lg shadow-2xl h-[400px] flex flex-col transition-all duration-500 ease-in-out group-hover:shadow-3xl group-hover:-translate-y-3 group-hover:border-red-500 group-hover:bg-white">
          <CardContent className="bg-[#f8f9e9] text-center flex flex-col justify-between h-full p-6">
  {/* ICON */}
  <div className="mx-auto mb-4 w-24 h-24 flex items-center justify-center rounded-full bg-red-500 p-5 border-4 border-transparent transition-all duration-500 group-hover:bg-[#f8f9e9] group-hover:border-red-500 group-hover:scale-110">
    <span className="text-white transition-all duration-500 group-hover:text-red-500">
      {React.cloneElement(item.icon, { sx: { fontSize: 60 } })}
    </span>
  </div>

  {/* TITLE - Ensures uniform height */}
  <Typography
    variant="h6"
    sx={{ fontWeight: "bold", minHeight: "60px" }}  // Ensure all titles have the same height
    component="h2"
    className="text-xl font-bold mb-2"
  >
    {item.title}
  </Typography>

  {/* DESCRIPTION - Ensures uniform height */}
  <Typography
    variant="body3"
    sx={{ minHeight: "80px" }}  // Set a minimum height for descriptions
    className="mb-2 text-justify"
  >
    {item.description}
  </Typography>

  {/* TAMIL DESCRIPTION - Ensures uniform height */}
  <Typography
    variant="body2"
    sx={{ minHeight: "80px" }}  // Set a minimum height for Tamil descriptions
    className="mt-2 text-justify"
  >
    {item.tamilDescription}
  </Typography>
</CardContent>

          </Card>
        </div>
      </Grid>
    ))}
  </Grid>
</Container>


  {/* Additional Initiatives */}
  <Container maxWidth="lg" className="mt-8">
    <Grid container spacing={4}>
      {[
        {
          title: "Swatch Bharat Initiative and Empowerment",
          description:
            "Further we take initiatives to get/provide basic sanitation facilities, disposal system of solid waste, village cleanliness, safe and adequate drinking water supply facility.",
          tamilDescription:
            "மேலும் அடிப்படை சுகாதார வசதிகள், திடக்கழிவுகளை அகற்றும் அமைப்பு, கிராம தூய்மை, பாதுகாப்பான மற்றும் போதுமான குடிநீர் விநியோக வசதி ஆகியவற்றைப் பெற/வழங்க நாங்கள் முன்முயற்சிகளை எடுக்கிறோம்.",
            icon: <CleaningServicesOutlinedIcon sx={{ fontSize: 60, color: 'white' }} />,
        },
        {
          title: "Cultural Heritage Temples",
          description:
            "The temples in our network include Arulmigu Neelayadakshi Udanurai Sri Kayakeswarar Temple, located in Erukattancherry (Mayiladuthurai District).",
          tamilDescription:
            "அருள்மிகு நீலாயதாட்சி உடனுறை ஸ்ரீ காலகாலேஸ்வரர் ஆலயம் எருக்கட்டாஞ்சேரி மயிலாடுதுறை மாவட்டம்.",
            icon: <TempleHinduOutlinedIcon sx={{ fontSize: 60, color: "white" }} />,
        },
        {
          title: "What Next?",
          description: "",
          tamilDescription: "",
          icon: <LightbulbOutlinedIcon sx={{ fontSize: 60, color: "white" }} />,
          onClick: () => {
            navigate("/whatsnext");
            window.scrollTo(0, 0); // Ensure smooth scroll to top
          },
        }        
      ].map((item, index) => (
        <Grid item xs={12} md={4} key={index}>
          {/* Group wrapper to apply hover effect to both card and icon */}
          <div className="group transition-all duration-500">
            <Card 
              className="bg-[#f8f9e9] border border-gray-300 rounded-lg shadow-2xl h-[470px] flex flex-col transition-all duration-500 ease-in-out group-hover:shadow-3xl group-hover:-translate-y-3 group-hover:border-red-500 group-hover:bg-white"
              onClick={item.onClick} // ✅ Attach onClick to the Card
              style={{ cursor: item.onClick ? "pointer" : "default" }} // Change cursor for clickable items
            >
              <CardContent className="bg-[#f8f9e9] text-center flex flex-col justify-between h-full p-6">
                {/* ICON - Moves & Changes Color with Card */}
                <div className="mx-auto mb-4 w-24 h-24 flex items-center justify-center rounded-full bg-red-500 p-5 border-4 border-transparent transition-all duration-500 group-hover:bg-[#f8f9e9] group-hover:border-red-500 group-hover:scale-110">
                  <span className="text-white transition-all duration-500 group-hover:text-red-500">
                    {React.cloneElement(item.icon, { sx: { fontSize: 60 } })}
                  </span>
                </div>

                <Typography variant="h6" sx={{ fontWeight: "bold" }} component="h2" className="text-xl font-bold mb-2">
                  {item.title}<br /><br />
                </Typography>
                <Typography variant="body3" className="mb-2 text-justify">
                  {item.description}<br /><br />
                </Typography>
                <Typography variant="body2" className="mt-2 text-justify">
                  {item.tamilDescription}
                </Typography>
              </CardContent>
            </Card>
          </div>
        </Grid>
      ))}
    </Grid>
  </Container>
</div>




      {/* Our Visions */}
      <Box sx={{ backgroundColor: "#f8f9e9", py: 6 }}>
  <Container>
    <Grid container spacing={4} alignItems="center">
      
      {/* 📍 1️⃣ Heading (Appears First in Mobile, Stays with Content in Desktop) */}
      <Grid 
        item xs={12} 
        sx={{ display: { xs: "block", md: "none" }, textAlign: "center", mb: 2 }}
      >
        <Typography variant="h4" sx={{ fontWeight: "bold", color: "#E52029", fontsize: "34px" }}>
          Our <span style={{ color: "#FAD707" }}>Vision</span>
        </Typography>
      </Grid>

      {/* 📍 2️⃣ Image Section (Right on Desktop, Below Heading on Mobile) */}
      <Grid item xs={12} md={6}>
        <Box
          component="img"
          src={tkstemple}
          alt="Temple"
          sx={{
            width: "100%",
            borderRadius: "8px",
            boxShadow: 3,
            display: "block",
            maxWidth: { xs: "90%", md: "100%" },  // Responsive width
            margin: "0 auto"
          }}
        />
      </Grid>

      {/* 📍 3️⃣ Content + Swiper (Left on Desktop, Below Image on Mobile) */}
      <Grid item xs={12} md={6} sx={{ position: "relative" }}>
        {/* 🖥️ Desktop Heading (Only visible on Desktop) */}
        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: "bold", 
            fontsize: "34px",
            color: "#E52029",
            display: { xs: "none", md: "block" } // Hide in mobile, show in desktop
          }}>
          Our <span style={{ color: "#FAD707" }}>Vision</span>
        </Typography>

        <Swiper
          navigation={{
            prevEl: ".custom-prev2",
            nextEl: ".custom-next2",
          }}
          autoplay={{ delay: 20000, disableOnInteraction: false }}
          loop={true}
          modules={[Navigation, Autoplay]}
          className="swiper-container"
        >
          <SwiperSlide>
            <Typography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: "16px",
                color: "black",
                lineHeight: 2.3,
                fontWeight: 500,
                textAlign: "justify",
                px: { xs: 2, md: 5 },  // Adjusted padding for mobile
              }}
            >
              To create a thriving force that grows together, serves one another, and upholds the values of service,
              education, and unity. Our trust operates with a service motive and no intention of profit, ensuring that
              all initiatives benefit everyone.
            </Typography>
          </SwiperSlide>

          <SwiperSlide>
            <Typography
              variant="body1"
              sx={{
                mt: 2,
                fontSize: "16px",
                color: "black",
                fontWeight: 500,
                lineHeight: 2.0,
                textAlign: "justify",
                px: { xs: 2, md: 5 },  // Adjusted padding for mobile
              }}
            >
              ஒருவருக்கொருவர் சேவை செய்து, சேவை, கல்வி மற்றும் ஒற்றுமை ஆகியவற்றின் மதிப்புகளை நிலைநிறுத்தும்
              ஒரு செழிப்பான சமூகத்தை உருவாக்குதல் ஆகும். எங்கள் அறக்கட்டளை ஒரு சேவை நோக்கத்துடன் லாப நோக்கமின்றி
              செயல்படுகிறது, அனைத்து முயற்சிகளும் மக்களுக்கு பயனளிக்கும் என்பதை உறுதி செய்கிறது.
            </Typography>
          </SwiperSlide>
        </Swiper>

        {/* Custom Navigation Buttons */}
        <button
  className="custom-prev2"
  style={{
    position: "absolute",
    top: "50%",
    left: "20px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❮
</button>

<button
  className="custom-next2"
  style={{
    position: "absolute",
    top: "50%",
    right: "-10px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❯
</button>

      </Grid>

    </Grid>
  </Container>
  <Box
  sx={{
    position: "relative",
    left:"50%",
    width: "40%",
    height: { xs: "80px", md: "150px" }, // Smaller height on mobile, larger on desktop
    backgroundImage: `url(${br})`,
    backgroundSize: "cover", // Ensures full coverage on all screen sizes
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    marginTop: { xs: "-50px", md: "-100px" }, // Adjusts placement for mobile & desktop
    zIndex: 0, // Ensures it stays below content
  }}
/>
</Box>
</Box>
  );
}

export default AboutUs;